import { ref, type Ref } from "vue";
import type FormCC from "@/interface/FormCC";
import MasterService from "@/service/restfulService/CCOnboardMasterService";
import type UploadFileValidity from "@/interface/UploadFileValidity";

export default function supplementaryUploadFileSubmit(
  ccFormValue: Ref<FormCC>,
  page11Overlay: Ref<boolean>,
  isTimeOut: Ref<boolean>,
  isSessionEnd: Ref<boolean>,
  suppStatus: Ref<string>,
  uploadFileValidity: Ref<UploadFileValidity>,
  jumpStep: (value: number, name: string, page: string) => void,
): void {
  isTimeOut.value = false;
  page11Overlay.value = true;
  if (
    uploadFileValidity.value.uploadFile1 == "invalidFileType" ||
    uploadFileValidity.value.uploadFile1 == "EC002"
  ) {
    uploadFileValidity.value.uploadFile1 = "";
  }
  const requestModel = {
    webFormRequestId: ccFormValue.value.webFormRequestId,
    suppFormRequestId: ccFormValue.value.supplementary.webFormRequestId,
    documentNameDTO: {
      supProofOfIdentities: {
        proofOfIdentityFileName:
          ccFormValue.value.supplementaryUploadDocument.proofIdentity
            .resumeDeletedFile,
      },
    },
  };
  MasterService.docCheck(requestModel, ccFormValue.value.token)
    .then((res) => {
      if (res.status == 200) {
        MasterService.suppDocSubmit(ccFormValue.value, ccFormValue.value.token)
          .then((res) => {
            if (res.status == 200) {
              if (res.data.responseModel.status == "EC001") {
                // if (res.data.responseModel.message) {
                //   uploadFileValidity.value.errorMessage1 =
                //     res.data.responseModel.message;
                // }
                page11Overlay.value = false;
                isTimeOut.value = true;
                uploadFileValidity.value.uploadFile1 =
                  res.data.responseModel.status;

                // supplementary identity file
                if (
                  res.data.responseModel.documentNameDTO.supProofOfIdentities &&
                  res.data.responseModel.documentNameDTO.supProofOfIdentities
                    .proofOfIdentityFileName &&
                  res.data.responseModel.documentNameDTO.supProofOfIdentities
                    .proofOfIdentityFileName.length != 0
                ) {
                  for (
                    let i = 0;
                    i <
                    res.data.responseModel.documentNameDTO.supProofOfIdentities
                      .proofOfIdentityFileName.length;
                    i++
                  ) {
                    for (
                      let j = 0;
                      j <
                      ccFormValue.value.supplementaryUploadDocument
                        .proofIdentity.fileName.length;
                      j++
                    ) {
                      if (
                        res.data.responseModel.documentNameDTO
                          .supProofOfIdentities.proofOfIdentityFileName[i] ==
                        ccFormValue.value.supplementaryUploadDocument
                          .proofIdentity.fileName[j]
                      ) {
                        ccFormValue.value.supplementaryUploadDocument.proofIdentity.invalidFile[
                          j
                        ] = true;
                        uploadFileValidity.value.uploadFile1 =
                          res.data.responseModel.status;
                      }
                    }
                  }
                }

                return;
              }
              // Malicious File
              else if (res.data.responseModel.status == "EC002") {
                page11Overlay.value = false;
                isTimeOut.value = true;

                if (
                  res.data.responseModel.documentNameDTO.supProofOfIdentities &&
                  res.data.responseModel.documentNameDTO.supProofOfIdentities
                    .proofOfIdentityFileName &&
                  res.data.responseModel.documentNameDTO.supProofOfIdentities
                    .proofOfIdentityFileName.length != 0
                ) {
                  const deletedNames: string[] = [];
                  for (
                    let i = 0;
                    i <
                    res.data.responseModel.documentNameDTO.supProofOfIdentities
                      .proofOfIdentityFileName.length;
                    i++
                  ) {
                    for (
                      let j =
                        ccFormValue.value.supplementaryUploadDocument
                          .proofIdentity.fileName.length - 1;
                      j >= 0;
                      j--
                    ) {
                      if (
                        res.data.responseModel.documentNameDTO
                          .supProofOfIdentities.proofOfIdentityFileName[i] ==
                        ccFormValue.value.supplementaryUploadDocument
                          .proofIdentity.fileName[j]
                      ) {
                        deletedNames.push(
                          ccFormValue.value.supplementaryUploadDocument
                            .proofIdentity.fileName[j],
                        );
                        ccFormValue.value.supplementaryUploadDocument.proofIdentity.fileName.splice(
                          j,
                          1,
                        );
                        ccFormValue.value.supplementaryUploadDocument.proofIdentity.file.splice(
                          j,
                          1,
                        );
                        ccFormValue.value.supplementaryUploadDocument.proofIdentity.fileNumber =
                          ccFormValue.value.supplementaryUploadDocument.proofIdentity.fileName.length;
                      }
                    }
                  }
                  if (deletedNames.length > 0) {
                    uploadFileValidity.value.uploadFile1 = "EC002";
                    uploadFileValidity.value.maliciousFile1Names = deletedNames;
                  }
                }
              } else {
                if (ccFormValue.value.isDraft) {
                  const newFormData = new FormData();
                  newFormData.append("", "");
                  ccFormValue.value.supplementaryUploadDocument.proofIdentity.file =
                    [];
                  if (res.data.responseModel.documentNameDTO) {
                    if (
                      res.data.responseModel.documentNameDTO
                        .supProofOfIdentities
                    ) {
                      if (
                        res.data.responseModel.documentNameDTO
                          .supProofOfIdentities.proofOfIdentityFileName.length >
                        0
                      ) {
                        ccFormValue.value.supplementaryUploadDocument.proofIdentity.fileName =
                          [];
                        for (
                          let i = 0;
                          i <
                          res.data.responseModel.documentNameDTO
                            .supProofOfIdentities.proofOfIdentityFileName
                            .length;
                          i++
                        ) {
                          ccFormValue.value.supplementaryUploadDocument.proofIdentity.fileName.push(
                            res.data.responseModel.documentNameDTO
                              .supProofOfIdentities.proofOfIdentityFileName[i],
                          );
                          ccFormValue.value.supplementaryUploadDocument.proofIdentity.file.push(
                            newFormData,
                          );
                        }
                        ccFormValue.value.supplementaryUploadDocument.proofIdentity.resumeFileNumber =
                          res.data.responseModel.documentNameDTO.supProofOfIdentities.proofOfIdentityFileName.length;
                      }
                    }
                  }
                }

                isTimeOut.value = true;
                page11Overlay.value = false;
                suppStatus.value = "N";
                ccFormValue.value.dropOffStep = 11;
                jumpStep(12, "", "11");
              }
            } else {
              page11Overlay.value = false;
              suppStatus.value = "F";
            }
          })
          .catch((e) => {
            if (e.response && e.response.data.code == "WB-401") {
              // EndSession
              isTimeOut.value = false;
              isSessionEnd.value = true;
            }
            page11Overlay.value = false;
            isTimeOut.value = true;
          });
      }
    })
    .catch((e) => {
      if (e.response && e.response.data.code == "WB-401") {
        // EndSession
        isTimeOut.value = false;
        isSessionEnd.value = true;
      }
      page11Overlay.value = false;
      isTimeOut.value = true;
    });
}
